import { Instagram, Twitter, Linkedin } from "lucide-react";
 
export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#FFFFFF] pt-24 pb-12">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 pb-16 border-b border-[#B1B7AB]/40">
          <div className="col-span-2">
            <a
              href="#top"
              className="flex items-center"
              data-testid="footer-logo"
            >
              <img
                src="/Lychee Logo_Single text logo.svg"
                alt="Lychee"
                className="h-9 w-auto"
              />
            </a>
            <p className="mt-4 text-sm text-[#0D3A35]/70 max-w-xs">
              The creator-visit company. Built for local businesses who want
              more foot traffic.
            </p>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-[#276152] font-semibold mb-4">
              Product
            </p>
            <ul className="space-y-3 text-sm text-[#0D3A35]/80">
              <li><a href="#how" className="hover:text-[#276152]">How it works</a></li>
              <li><a href="#contracts" className="hover:text-[#276152]">Contracts</a></li>
              <li><a href="#creators" className="hover:text-[#276152]">Creators</a></li>
              <li><a href="#faq" className="hover:text-[#276152]">FAQ</a></li>
            </ul>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-[#276152] font-semibold mb-4">
              Company
            </p>
            <ul className="space-y-3 text-sm text-[#0D3A35]/80">
              <li><button type="button" onClick={() => document.querySelector('[data-testid="header-cta"]')?.click()} className="hover:text-[#276152]">Book consultation</button></li>
              <li><a href="mailto:hello@lycheeasia.com" className="hover:text-[#276152]">hello@lycheeasia.com</a></li>
              <li><span className="text-[#0D3A35]/50">Privacy</span></li>
              <li><span className="text-[#0D3A35]/50">Terms</span></li>
            </ul>
          </div>
        </div>
        <div className="pt-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <p className="text-xs text-[#276152]/80">
            © {new Date().getFullYear()} Lychee. Built for venues that
            deserve to be seen.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" aria-label="Instagram" data-testid="social-instagram" className="text-[#0D3A35]/70 hover:text-[#276152]">
              <Instagram className="w-4 h-4" strokeWidth={1.6} />
            </a>
            <a href="#" aria-label="Twitter" data-testid="social-twitter" className="text-[#0D3A35]/70 hover:text-[#276152]">
              <Twitter className="w-4 h-4" strokeWidth={1.6} />
            </a>
            <a href="#" aria-label="LinkedIn" data-testid="social-linkedin" className="text-[#0D3A35]/70 hover:text-[#276152]">
              <Linkedin className="w-4 h-4" strokeWidth={1.6} />
            </a>
          </div>
        </div>
        <div className="mt-20 pb-2 overflow-hidden">
          <p className="font-serif text-[clamp(4rem,18vw,16rem)] leading-none tracking-tighter text-[#0D3A35]/90 select-none">
            Lychee<span className="text-[#276152]">.</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
